/*
 *
 * EditCompanyPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 02-Apr-2025
 */

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  cancel: <PortalMessage id='t.app.cancel' defaultMessage='Annulla' />,
  shopAlias: <PortalMessage id='t.app.companydata.detail.shop.alias' defaultMessage='Nome personalizzato' />,
  modalCustomName: (
    <PortalMessage id='t.app.companydata.detail.modal.customName' defaultMessage='Identificativo punto vendita' />
  ),
  modalEditNameTitle: (
    <PortalMessage
      id='t.app.companydata.detail.modal.editName.title'
      defaultMessage='Modifica il nome del punto vendita.'
    />
  ),
  modalEditNameSubtitle: (
    <PortalMessage
      id='t.app.companydata.detail.modal.editName.subtitle'
      defaultMessage='Puoi personalizzare il nome del tuo punto vendita per poterlo identificare con facilità all’interno di Nexi Business. Tieni presente che i dati della tua società non verranno modificati.'
    />
  ),
  modalEditShopAlias: (
    <PortalMessage
      id='t.app.companydata.detail.modal.editName.tooltip'
      defaultMessage='Il campo corrisponde al nome dello stabilimento visualizzato su Merchant Portal, i dati della tua società non verranno modificati.'
    />
  ),
  requiredError: <PortalMessage id='t.app.error.requiredField' defaultMessage='Il campo è obbligatorio' />,
  confirm: <PortalMessage id='t.app.confirm' defaultMessage='Conferma' />
}

export default formattedMessage
